/* @jsxImportSource @emotion/react */

import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { CustomerLogoBanner } from '@slite/components'

import { Section } from '../../components/Section'
import { SocialProofs } from '../../components/SocialProofs'
import { WebsiteText } from '../../components/WebsiteText'
import checkdrawn from './check-drawn.webp'
import { BookDemoForm } from './Form'

export function SectionBookDemo() {
  const intl = useIntl()
  const items = [
    intl.formatMessage({
      id: 'bookdemo.item1',
      defaultMessage: 'Request a demo, watch Slite in action.',
    }),
    intl.formatMessage({
      id: 'bookdemo.item2',
      defaultMessage: 'Discuss pricing and use-cases.',
    }),
    intl.formatMessage({
      id: 'bookdemo.item3',
      defaultMessage: 'Get onboarding help.',
    }),
    intl.formatMessage({
      id: 'bookdemo.item4',
      defaultMessage: 'Get a sneak peek at our roadmap.',
    }),
  ]

  return (
    <Section background="moon-dust" containerVerticalPadding={60}>
      {/* <!-- Calendly link widget begin --> */}
      <link
        href="https://assets.calendly.com/assets/external/widget.css"
        rel="stylesheet"
      />
      <script
        src="https://assets.calendly.com/assets/external/widget.js"
        type="text/javascript"
        async
      ></script>
      {/* <!-- Calendly link widget end --></link> */}
      <div className="grid-12 flexbox-wrap">
        <div className="grid-span-6-large grid-span-12 padding-right-32">
          <WebsiteText variant="heroTitle" className="margin-top-32">
            <FormattedMessage
              id="bookdemo.h1"
              defaultMessage="Talk to our sales team"
            />
          </WebsiteText>

          <ul className="margin-vertical-16 padding-bottom-20">
            {items.map((item, index) => (
              <li
                key={index}
                className="font-size-4-large font-size-6 line-height-copy flexbox flexbox-align-center"
              >
                <img
                  src={checkdrawn}
                  width={16}
                  height={16}
                  alt=""
                  className="margin-right-8"
                />
                {item}
              </li>
            ))}
          </ul>
          <div className="display-none-small display-none-medium">
            <SocialProofs />
          </div>
        </div>
        <div className="grid-span-6-large grid-span-12">
          <div className="background-white padding-24 radius-large shadow-small">
            <BookDemoForm />
          </div>
        </div>
      </div>
      <div className="margin-top-32">
        <div className="padding-top-60 font-size-3-not-medium font-size-4  text-align-center line-height-title font-weight-semibold">
          <FormattedMessage
            id="index.demo.customers"
            defaultMessage="1,700+ leading companies trust Slite as their single source of truth."
          />
          <CustomerLogoBanner
            containerClass=" margin-top-16"
            animated={false}
          />
        </div>
      </div>
    </Section>
  )
}
